module.exports = __webpack_public_path__ + "img/Dantam Hair 39.c0fbff1e.jpg";